import Head from "next/head";
import RequestDemo from "components/request-demo";

const CLMRequestDemo = () => {
  return (
    <>
      <Head>
        <title>Request a Demo - BoloSign CLM</title>
        <meta
          name="description"
          content="Request a personalized demo of BoloSign's Contract Lifecycle Management (CLM) solution. Discover how our platform can streamline your contract processes and improve efficiency."
        />
        <meta
          name="keywords"
          content="BoloSign CLM demo, request CLM demo, contract lifecycle management demo, BoloSign contract management, CLM solution demo"
        />
        <link rel="canonical" href="https://www.bolosign.com/clm/request-demo/" />
      </Head>
      <div className="w-full lg:h-[850px] flex items-center justify-center">
        <RequestDemo />
      </div>
    </>
  );
};

export default CLMRequestDemo;
